import React, {useEffect, useState} from "react";
import ApiService from "../ApiService";
import {Container, Row, Badge, Col, ListGroup} from 'react-bootstrap'
import Message from "./Message";
import SentMessage from "./SentMessage";
import SendMessage from "./SendMessage";
import removeClass from "../util/RemoveCSS";
import './message.css';
import { BsFillArchiveFill } from 'react-icons/bs';
import { IoSend } from 'react-icons/io5';
import { IoIosCreate } from 'react-icons/io';
import { TfiReload } from "react-icons/tfi";
import PageTitle from "./Common/PageTitle/PageTitle";
import SentMessageOthers from "./SentMessageOthers";
import {isAuditorReadOnlyRole, isSuperAdminRole} from "../util/authUtil";

const Inbox = () => {
    const [messages, setmessages] = useState(null);
    const [msgNum, setMsgNum] = useState("");
    const [inboxMessages, setInboxMessages] = useState(true);
    const [sentMessages, setSentMessages] = useState(false);
    const [sentMessagesOthers, setSentMessagesOthers] = useState(false);
    const [hasPermissionToViewOthersSent, setHasPermissionToViewOthersSent] = useState(false);
    const [sendMessage, setSendMessage] = useState(false);
    const [backToInbox, setBackToInbox] = useState(false);
    const [backToSentMessages, setBackToSentMessages] = useState(false);
    const [backToSentOthersMessages, setBackToSentOthersMessages] = useState(false);
    const [pid, setPid] = useState(null);
    const [loading, setLoading] = useState(false);
    const [reloadInboxMessages, setReloadInboxMessages] = useState(false);
    
    removeClass();
    document.body.classList.add("body_inbox");

    useEffect(() => {
        const setFlags = async () => {
             const isAdmin = await isSuperAdminRole();
            const isAuditor = await isAuditorReadOnlyRole();

            if(isAdmin || isAuditor){
                return setHasPermissionToViewOthersSent(true);
            } else {
                return setHasPermissionToViewOthersSent(false);
            }
        }
        setFlags();

        loadMessages();
    }, []);

    useEffect(() => {
        var unreadMessageCount = 0;
        if (messages) {
            for (let m of messages) {
                if (m.unread) {
                    unreadMessageCount++;
                }
            }
            setMsgNum(unreadMessageCount);
        }
    }, [messages]);
    useEffect(() => {
        // Parse the current URL
        const queryParams = new URLSearchParams(window.location.search);
        const pid = queryParams.get('pid');
        if (pid) {
            setPid(pid);
            sendMsgButton();
        }
      }, []);

    const loadMessages = async () => {
        if (!loading) {
            setLoading(true);
            try {
                const getMessages = await ApiService.getMessages();
                setmessages(getMessages.data);
            } catch(ex) {
                console.error(ex);
            }
            setLoading(false);
        }
    };

    const inboxButton = () => {
        setInboxMessages(true)
        setSentMessages(false)
        setSendMessage(false)
        setSentMessagesOthers(false)
        setBackToInbox(!backToInbox)
    };

    const sentMsgButton = () => {
       setInboxMessages(false)
        setSentMessages(true)
        setSentMessagesOthers(false);
        setSendMessage(false)
        setBackToSentMessages(!backToSentMessages)
    };

    const sentMsgOthersButton = () => {
        setInboxMessages(false)
        setSentMessages(false)
        setSendMessage(false)
        setSentMessagesOthers(true)
        setBackToSentOthersMessages(!backToSentOthersMessages)
    };

    const sendMsgButton = () => {
        setInboxMessages(false)
        setSentMessages(false)
        setSendMessage(true)
    };

    const reduceUnreadCount = () => {
        setMsgNum(msgNum - 1);
    };

    const reloadMessages = () => {
        if (!reloadInboxMessages) {
            setReloadInboxMessages(true);
            loadMessages();
        }
    };

    const updateReloadInboxMessages = () => {
        setReloadInboxMessages(false);
    };

    return (
        <Container fluid>
            <div style={{ display: "flex", alignItems: "center", flexDirection: "row" }}>
                <h1 className="heading mar-t-2">My Messages</h1>
                <TfiReload
                    onClick={reloadMessages}
                    isLoading={loading || reloadInboxMessages}
                    size={30}
                    style={{
                        marginTop: "15px",
                        marginLeft: "20px",
                        cursor: loading || reloadInboxMessages ? "auto" : "pointer",
                        color: loading || reloadInboxMessages ? "gray" : "black",
                        animation: loading || reloadInboxMessages ? "spin 1s linear infinite" : "none"
                    }}
                />
            </div>
            
            <Row>
                <Col md={2} className="align-items-center Top-panel">
                    <ListGroup>
                        <ListGroup.Item id="msgMenuItems" onClick={() => inboxButton()} active={inboxMessages}>
                                <p class="panelText"> <span className="panelIcon"><BsFillArchiveFill/></span> Inbox <Badge bg="warning">{msgNum > 0 ? msgNum : ""}</Badge> </p>
                        </ListGroup.Item>
                        <ListGroup.Item id="msgMenuItems" onClick={() => sentMsgButton()} active={sentMessages}>
                                <p class="panelText"> <span className="panelIcon"><IoSend/></span> Sent </p>
                        </ListGroup.Item>
                        {hasPermissionToViewOthersSent && (<ListGroup.Item id="msgMenuItems" onClick={() => sentMsgOthersButton()} active={sentMessagesOthers}>
                            <p class="panelText"> <span className="panelIcon"><IoSend/></span> Sent - Other Clinicians</p>
                        </ListGroup.Item>)}
                        <ListGroup.Item id="msgMenuItems" onClick={() => sendMsgButton()} active={sendMessage}>
                                <p class="panelText"> <span className="panelIcon"><IoIosCreate/></span> New Message</p>
                        </ListGroup.Item>
                    </ListGroup>
                </Col>
                <Col md={10}>
                    {inboxMessages &&
                        <Message
                            goBack={backToInbox}
                            reduce={reduceUnreadCount}
                            reloadInboxMessages={reloadInboxMessages}
                            updateReloadInboxMessages={updateReloadInboxMessages}
                        />
                    }
                    {sentMessages &&
                        <SentMessage goBack={backToSentMessages}/>
                    }
                    {sentMessagesOthers &&
                        <SentMessageOthers goBack={backToSentMessages}/>
                    }
                    {sendMessage &&
                        <SendMessage pId={ pid} />
                    }
                </Col>
            </Row>
        </Container>
    )
};
export default Inbox;
